import React from 'react';
import { withRouter } from 'react-router';
import { Button, Alert } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import queryString from 'querystring';

import s from './style.less';
import ProviderBlock from '../../components/NavBar';
import Breadcreumb from '../../components/Breadcrumb';
import Booking from '../../components/Book';
import renderInput from '../../components/form/Input';
import Calendar from '../../components/Datepicker';
import ChangeDealer from './changeDealer';
import Underfunded from '../../containers/Underfunded';

class Book extends React.Component {
  static propTypes = {
    match: PropTypes.object,
  };
  state = {
    components: [],
    plan: false,
    ticked: [],
    ticked2: [],
    provider: false,
    date: null,
    error: '',
    disabled: false,
    currentMileage: '',
    debts: [],
    car: false,
    car2: false,
  };

  componentDidMount() {
    this.getComponents();
  }

  getComponents = async () => {
    const { id } = this.props.match.params;
    const { plan, car, car2 } = await fetch(
      `/customer/booking-components/${id}`,
    );
    this.setState({
      plan,
      car,
      car2,
      components: plan.Components,
      provider: plan.Provider,
    });
  };

  getDebts = async (componentId = this.state.triedToSelect) => {
    const debts = await fetch(
      `/user/underfunded?planId=${this.state.plan.id}&${queryString.stringify({
        componentId: [...this.state.ticked, componentId],
      })}`,
    );
    this.setState({ debts, triedToSelect: componentId });
  };
  getDebts2 = async (componentId = this.state.triedToSelect) => {
    const debts = await fetch(
      `/user/underfunded?planId=${this.state.plan.id}&${queryString.stringify({
        componentId: [...this.state.ticked2, componentId],
      })}`,
    );
    this.setState({ debts, triedToSelect: componentId });
  };
  tickBooking = async ({ id }) => {
    await this.getDebts(id);
    if (this.state.debts.length > 0) return;
    if (this.state.ticked.includes(id)) {
      this.setState({ ticked: this.state.ticked.filter(x => x !== id) });
    } else {
      this.setState({ ticked: [...this.state.ticked, id] });
    }
  };
  tickBooking2 = async ({ id }) => {
    await this.getDebts2(id);
    if (this.state.debts.length > 0) return;
    if (this.state.ticked2.includes(id)) {
      this.setState({ ticked2: this.state.ticked2.filter(x => x !== id) });
    } else {
      this.setState({ ticked2: [...this.state.ticked2, id] });
    }
  };
  breadcrumbs = [
    { name: 'Home', to: '/' },
    {
      name: 'Service Plans',
      to: '/provider/bookings',
      react: true,
    },
    { name: 'Book your Appointment' },
  ];
  selectDate = date => this.setState({ date });

  submit = async vrn2 => {
    if (!this.state.currentMileage) {
      return this.setState({
        error: 'Please enter current mileage',
      });
    }
    if (!this.state.date) {
      return this.setState({
        error: 'Please select date',
      });
    }
    this.setState({
      error: false,
      disabled: true,
    });
    try {
      const ticked = vrn2 ? this.state.ticked2 : this.state.ticked;
      for (const id of ticked) {
        await fetch(`/customer/book-plan/${id}`, {
          method: 'post',
          body: {
            componentId: id,
            date: this.state.date,
            currentMileage: this.state.currentMileage,
            ProviderId: this.state.provider.id,
          },
        });
      }
      this.getComponents();
      if (vrn2) {
        this.setState({ ticked2: [] });
      } else {
        this.setState({ ticked: [] });
      }
    } catch (e) {
      this.setState({ error: e.error.toString() });
    }
    this.setState({
      disabled: false,
    });
  };

  changeDealer = provider => {
    this.setState({
      provider,
    });
  };
  renderBooking = (x, index) => {
    if (!x.Booking) {
      return (
        <Booking
          statusType="plus-circle-o"
          key={index}
          item={x}
          onClick={this.tickBooking}
          ticked={this.state.ticked.includes(x.id)}
        />
      );
    }
    const status = x.Booking.BookingStatus.driverMessage;
    if (status === 'Work Done') {
      return <Booking gray statusType="check-circle-o" key={index} item={x} />;
    }
    if (status === 'Booking Confirmed' || status === 'Booking Requested') {
      return <Booking inProgress statusType="setting" key={index} item={x} />;
    }
  };
  renderBooking2 = (x, index) => {
    if (!x.Booking) {
      return (
        <Booking
          statusType="plus-circle-o"
          key={index}
          item={x}
          onClick={this.tickBooking2}
          ticked={this.state.ticked2.includes(x.id)}
        />
      );
    }
    const status = x.Booking.BookingStatus.driverMessage;
    if (status === 'Work Done') {
      return <Booking gray statusType="check-circle-o" key={index} item={x} />;
    }
    if (status === 'Booking Confirmed' || status === 'Booking Requested') {
      return <Booking inProgress statusType="setting" key={index} item={x} />;
    }
  };

  render() {
    let value = moment().add(3, 'days');
    const closedDays = [0, 6];
    while (closedDays.indexOf(value.day()) !== -1) {
      value = value.add(1, 'days');
    }
    const shiftDate = 4 - value.day(); // This makes that, so selected date is always in the center of calendar block.
    return (
      <ProviderBlock withPadding>
        {this.state.debts.length > 0 && (
          <Underfunded debts={this.state.debts} getDebts={this.getDebts} />
        )}
        <Breadcreumb paths={this.breadcrumbs} />
        <div className={s.root}>
          <div className={s.header}>Request Your Service</div>
          <div>
            <div className={s.customerPhoto} />
            <div className={s.customerContacts}>
              <div className={s.customerName}>
                {this.state.provider.companyName}
              </div>
              <div className={s.customerAddress}>
                {this.state.provider.addressLine1}{' '}
                {this.state.provider.addressLine2} {this.state.provider.city},{' '}
                {this.state.provider.postcode}
              </div>
              <b>Plan number: {this.state.plan.contractNumber}</b>
              <div>
                Tel:{' '}
                {this.state.provider.mobilePhone || this.state.provider.phone}
              </div>
            </div>
          </div>
          <ChangeDealer
            activeDealerId={this.state.plan.ProviderId}
            select={this.changeDealer}
          />
          <hr />
          <br />
          <div className={s.table}>
            <div className={s.col1}>
              {this.state.car && (
                <div>
                  <div>
                    <img
                      src={`http://www2.carwebuk.com/${
                        this.state.car.specs.carPhoto
                      }`}
                    />
                  </div>
                  <div>
                    {this.state.car.maker.name} {this.state.car.model.name}&nbsp;
                    <b>({this.state.plan.VRN}</b>)
                  </div>
                </div>
              )}
            </div>
            <div className={s.col2}>
              {this.state.components
                .filter(x => x.carNumber === 1)
                .map(this.renderBooking)}
            </div>
          </div>
          {this.state.ticked.length > 0 && (
            <div>
              <div className={s.flex}>
                <div>
                  <div className={s.customerName}>Request A Day & Time</div>
                </div>
                <div>
                  <div>Current mileage</div>
                  <div className={s.mileage}>
                    {renderInput({
                      meta: false,
                      input: {
                        type: 'number',
                        value: this.state.currentMileage,
                        onChange: e =>
                          this.setState({ currentMileage: e.target.value }),
                      },
                    })}
                  </div>
                </div>
              </div>
              <div className={s.calendar}>
                <Calendar
                  onChange={this.selectDate}
                  dealerId={this.state.plan.ProviderId}
                  closedDays={[0, 6]}
                  shiftDate={shiftDate}
                  timeRange={[
                    { label: 'AM', value: '11:59:59' },
                    { label: 'PM', value: '23:59:59' },
                  ]}
                  unavailableLabel="Unavailable"
                  value={value.format('YYYY-MM-DD 11:59:59')}
                  startDate={value.format('YYYY-MM-DD 00:00:00')}
                />
              </div>
              <div className={s.buttons}>
                <Button onClick={() => this.setState({ ticked: [] })}>
                  Cancel
                </Button>
                &nbsp; &nbsp; &nbsp; &nbsp;
                <Button
                  type="primary"
                  onClick={() => this.submit()}
                  disabled={this.state.disabled}
                >
                  Confirm Request
                </Button>
              </div>
              <br />
              {this.state.error && (
                <Alert type="error" message={this.state.error} />
              )}
            </div>
          )}
          {this.state.plan.VRN2 && (
            <div>
              <br />
              <br />
              <br />
              <div className={s.table}>
                <div className={s.col1}>
                  {this.state.car2 && (
                    <div>
                      <div>
                        <img
                          src={`http://www2.carwebuk.com/${
                            this.state.car2.specs.carPhoto
                          }`}
                        />
                      </div>
                      <div>
                        {this.state.car2.maker.name}{' '}
                        {this.state.car2.model.name}&nbsp;
                        <b>({this.state.plan.VRN2}</b>)
                      </div>
                    </div>
                  )}
                </div>
                <div className={s.col2}>
                  {this.state.components
                    .filter(x => x.carNumber === 2)
                    .map(this.renderBooking2)}
                </div>
              </div>
            </div>
          )}
          {this.state.ticked2.length > 0 && (
            <div>
              <div className={s.flex}>
                <div>
                  <div className={s.customerName}>Request A Day & Time</div>
                </div>
                <div>
                  <div>Current mileage</div>
                  <div className={s.mileage}>
                    {renderInput({
                      meta: false,
                      input: {
                        type: 'number',
                        value: this.state.currentMileage,
                        onChange: e =>
                          this.setState({ currentMileage: e.target.value }),
                      },
                    })}
                  </div>
                </div>
              </div>
              <div className={s.calendar}>
                <Calendar
                  onChange={this.selectDate}
                  dealerId={this.state.plan.ProviderId}
                  closedDays={[0, 6]}
                  shiftDate={shiftDate}
                  timeRange={[
                    { label: 'AM', value: '11:59:59' },
                    { label: 'PM', value: '23:59:59' },
                  ]}
                  unavailableLabel="Unavailable"
                  value={value.format('YYYY-MM-DD 11:59:59')}
                  startDate={value.format('YYYY-MM-DD 00:00:00')}
                />
              </div>
              <div className={s.buttons}>
                <Button onClick={() => this.setState({ ticked2: [] })}>
                  Cancel
                </Button>
                &nbsp; &nbsp; &nbsp; &nbsp;
                <Button
                  type="primary"
                  onClick={() => this.submit(2)}
                  disabled={this.state.disabled}
                >
                  Confirm Request
                </Button>
              </div>
              <br />
              {this.state.error && (
                <Alert type="error" message={this.state.error} />
              )}
            </div>
          )}
        </div>
      </ProviderBlock>
    );
  }
}

export default withRouter(Book);
